import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				position: "relative",
				overflowY: "hidden"
			},
			rootFooter: {
				position: "absolute",
				zIndex: 5,
				bottom: 0
			},
			promotion: {
				background: theme.palette.common.white,
				boxShadow: "0px 3px 29px rgb(0 0 0 / 15%)",
				borderRadius: 6,
				padding: 10
			},
			titlePromotion: {
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				paddingBottom: 5,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`
			},
			rootBodyPage: {
				overflowY: "scroll"
			},
			totalBox: {
				padding: 10,
				background: theme.palette.common.white,
				width: "100%",
				borderRadius: 6,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)"
			},
			text: {
				color: theme.palette.grey[50],
				fontSize: 12,
				textAlign: "center"
			},
			btnSubmit: {
				borderRadius: 6,
				width: "100%",
				textAlign: "center",
				padding: 12,
				marginTop: 10,
				"& > span": {
					fontWeight: 600
				},
				"&&:active": {
					opacity: 0.7
				}
			}
		}),
	{
		name: "CartsPage",
		index: 1
	}
);

export default useStyles;
